import { centroid } from "@turf/turf";

export const isObjectEmpty = (obj) => {
  if (typeof obj === "object" && obj !== null) {
    return Object.keys(obj).length === 0 && obj.constructor === Object;
  }

  return true;
};

export const capitalizeWord = (word) => {
  if (typeof word !== "string" || word.length === 0) {
    return "";
  }
  return word?.charAt(0)?.toUpperCase() + word?.slice(1)?.toLowerCase();
};

export const getPolygonCentroid = (latlngs) => {
  let area = 0;
  let x = 0;
  let y = 0;

  latlngs.forEach((latlng, i) => {
    const nextLatlng = latlngs[i + 1] || latlngs[0];
    const f = latlng.lat * nextLatlng.lng - nextLatlng.lat * latlng.lng;
    x += (latlng.lat + nextLatlng.lat) * f;
    y += (latlng.lng + nextLatlng.lng) * f;
    area += f / 2;
  });

  const finalX = x / (6 * area);
  const finalY = y / (6 * area);

  return { lat: finalX, lng: finalY };
};

export const getMapboxPolygonCentroid = (coordinates) => {
  const feature = {
    type: "Feature",
    geometry: {
      type: "Polygon",
      coordinates: [coordinates],
    },
  };
  const center = centroid(feature);
  return center.geometry.coordinates; // [lng, lat]
};

export const formatLocationName = (location) => {
  if (!location) return "";
  return location.replace(/,/g, " •");
};

export const convertHexToRGBA = (hexCode, opacity = 1) => {
  let hex = hexCode.replace("#", "");

  if (hex.length === 3) {
    hex = `${hex[0]}${hex[0]}${hex[1]}${hex[1]}${hex[2]}${hex[2]}`;
  }

  const r = parseInt(hex.substring(0, 2), 16);
  const g = parseInt(hex.substring(2, 4), 16);
  const b = parseInt(hex.substring(4, 6), 16);

  if (opacity > 1 && opacity <= 100) {
    opacity = opacity / 100;
  }

  return `rgba(${r},${g},${b},${opacity})`;
};

export const isValidURL = (urlStr) => {
  var pattern = new RegExp(
    "^(https?:\\/\\/)?" + // protocol
      "((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|" + // domain name
      "((\\d{1,3}\\.){3}\\d{1,3}))" + // OR ip (v4) address
      "(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*" + // port and path
      "(\\?[;&a-z\\d%_.~+=-]*)?" + // query string
      "(\\#[-a-z\\d_]*)?$",
    "i"
  ); // fragment locator
  return !!pattern.test(urlStr);
};

export const isValidateEmail = (email) => {
  return String(email)
    .toLowerCase()
    .match(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    );
};

export const getColorFromUsername = (username) => {
  const firstChar = username?.charAt(0);

  const asciiValue = firstChar?.charCodeAt(0);

  //  Generate RGB values
  const r = (asciiValue * 123) % 256;
  const g = (asciiValue * 456) % 256;
  const b = (asciiValue * 789) % 256;

  // Return the RGB color
  return `rgb(${r}, ${g}, ${b})`;
};

export function getTextWidth(text, font) {
  const canvas = document.createElement("canvas");
  const context = canvas.getContext("2d");

  context.font = font || getComputedStyle(document.body).font;

  return context.measureText(text).width;
}

export const tickFormatter = (value) => {
  const maxLength = 10;
  if (value.length <= maxLength) return value;

  return `${value.slice(0, maxLength)}...`;
};
